import styled from "styled-components";

export const BottomFixedContainer = styled.div`
  background: #ffffff;
  position: fixed;
  width: 100%;
  max-width: 880px;
  z-index: 1000;
  bottom: 0;
  left: 50%;
  transform: translateX(-43%);
  padding-bottom: 20px;

  @media (max-width: 1280px) {
    max-width: 70%;
    left: 55%;
  }

  @media (max-width: 1000px) {
    max-width: 65%;
    left: 62%;
  }

  @media (max-width: 768px) {
    max-width: 93%;
    left: 44%;
  }
`;

export const FlexContainer = styled.div`
  width: 99%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextAreaContainer = styled.div`
  width: 100%;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // position: relative;
  // gap: 10px;

  color: #3e4352;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  line-height: 1;
  box-sizing: border-box;

  & {
    scrollbar-width: thin;
    scrollbar-color: #545454 #ffffff;
    background-color: #f3f6f9;
  }

  .add-button {
    background: none;
    border: none;
    cursor: pointer;
    z-index: 2;
  }
`;

export const StyledTextArea = styled.textarea`
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  color: #3e4352;
  background: #fff;
  font-size: 14px;
  line-height: 1;
  box-sizing: border-box;
  max-width: 806px;
  max-height: 160px;
  height: 50px;
  line-height: 130%;
  padding: 15px 0;

  & {
    scrollbar-width: thin;
    scrollbar-color: #545454 #ffffff;
    background-color: #f3f6f9;
  }

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #808080;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }

  &::placeholder {
    color: #3e435270;
  }
`;
